$(document).ready(function () {

  function expandGrowthGridIfExists(callback) {
    const btn = document.getElementById('expand-growth-grid');
    const block = document.getElementById('growth-grid-block');

    if (btn && block) {
      const isAlreadyExpanded = block.classList.contains('is-expanded');

      block.classList.add('is-expanded');

      if (isAlreadyExpanded) {
        if (callback) callback();
        return;
      }

      let called = false;

      function done() {
        if (called) return;
        called = true;
        if (callback) callback();
      }

      block.addEventListener('transitionend', function handler(e) {
        if (e.target !== block) return;
        block.removeEventListener('transitionend', handler);
        done();
      });

      setTimeout(done, 400);
    } else {
      if (callback) callback();
    }
  }

  function scrollToHash(hash) {
    const target = $(hash);
    if (!target.length) return;

    let scrollPosition;

    if (target.hasClass('scroll-top')) {
      const offsetTop = 120;
      scrollPosition = target.offset().top - offsetTop;
    } else {
      const windowHeight = $(window).height();
      const elementHeight = target.outerHeight();
      const elementTop = target.offset().top;

      const positionPercent = 0.65;
      scrollPosition =
        elementTop - windowHeight * positionPercent + elementHeight / 2;
    }

    $("html, body").animate(
      { scrollTop: scrollPosition },
      500
    );
  }

  $("a").on("click", function (e) {
    if (
      $(this).data("local-scroll") ||
      !this.hash ||
      this.classList.contains("no-scrolling")
    ) return;

    if (
      this.pathname === location.pathname &&
      this.hostname === location.hostname
    ) {
      e.preventDefault();

      expandGrowthGridIfExists(() => {
        scrollToHash(this.hash);
      });
    }
  });

  if (window.location.hash) {
    expandGrowthGridIfExists(() => {
      scrollToHash(window.location.hash);
    });
  }

});